import React from "react";
import styles from './index.module.css';

const cx = require('classnames');

interface AdaptiveImageProp {
  name: string;
  className?: string
}

const AdaptiveImage: React.FC<AdaptiveImageProp> = (props) => {
  const devicePixelRatio = Math.floor(window.devicePixelRatio);
  const ratio = devicePixelRatio > 3 ? 3 : devicePixelRatio;
  const url = `${props.name}@${ratio}x.png`;

  return <img className={cx(styles.image, props.className)} src={require(`@/assets/image/${url}`)} alt="" />;
};

export default AdaptiveImage;
